import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Home, Users, BarChart3, FileText, PlayCircle, ShieldCheck, Database } from 'lucide-react';

const Sidebar = ({ user }) => {
  const location = useLocation();

  const menuItems = [
    { path: '/', label: 'Dashboard', icon: Home },
    { path: '/analytics', label: 'Analytics', icon: BarChart3 },
    { path: '/documents', label: 'Document Manager', icon: FileText },
    { path: '/data-sources', label: 'Data Sources', icon: Database },
    { path: '/tenants', label: 'Tenant Manager', icon: Users },
    { path: '/preview', label: 'Chat Preview', icon: PlayCircle },
    ...(user?.role === 'superadmin' ? [{ path: '/users', label: 'User Management', icon: ShieldCheck }] : []),
  ];

  return (
    <div className="sidebar">
      <ul className="sidebar-nav">
        {menuItems.map((item) => {
          const Icon = item.icon;
          const isActive = location.pathname === item.path;
          return (
            <li key={item.path}>
              <Link
                to={item.path}
                className={isActive ? 'active' : ''}
                style={{ display: 'flex', alignItems: 'center', gap: '12px' }}
              >
                <Icon size={18} />
                {item.label}
              </Link>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default Sidebar;
